import Vue from "vue";
import Vuex from "vuex";
import appModule from "./modules/app";
import groupModule from "./modules/group";
import canBoModule from "./modules/can-bo";
import commonModule from "./modules/common";
import donViModule from "./modules/don-vi";
import thongBaoTuyChinhModule from "./modules/thong-bao-tuy-chinh";
import chucVuModule from "./modules/chuc-vu";
import nhomChucVuModule from "./modules/nhom-chuc-vu";
import capDonViModule from "./modules/cap-don-vi";
import dmHeThongModule from "./modules/dm-he-thong";
import dmMenuHeThongModule from "./modules/dm-menu-he-thong";
import dmTinhThanhModule from "./modules/dm-tinh-thanh";
import dmNhomMenuModule from "./modules/dm-nhom-menu";
import userModule from "./modules/user";
import roleModule from "./modules/role";
import permissionModule from "./modules/permission";
import lichLamViecModule from "./modules/lich-lam-viec";
import logModule from "./modules/log";
import importService from "./modules/import-service";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common: commonModule,
    donVi: donViModule,
    thongBaoTuyChinh: thongBaoTuyChinhModule,
    chucVu: chucVuModule,
    nhomChucVu: nhomChucVuModule,
    dmHeThong: dmHeThongModule,
    dmMenuHeThong: dmMenuHeThongModule,
    dmNhomMenu: dmNhomMenuModule,
    app: appModule,
    canBo: canBoModule,
    user: userModule,
    role: roleModule,
    permission: permissionModule,
    lichLamViec: lichLamViecModule,
    group: groupModule,
    log: logModule,
    importService: importService,
    capDonVi: capDonViModule,
    dmTinhThanh: dmTinhThanhModule
  },
  state: {},
  getters: {},
  mutations: {}
});
